import { Navigate, Outlet } from 'react-router-dom';

import { FullPageSpinner } from '@/components/ui/Spinner';
import type { UserRole } from '@/types/app';
import { useProfile } from './useProfile';

/**
 * Route-level role gate — the other half of the "sees only what their role permits"
 * criterion. Hiding a menu item is presentation; this is what happens when someone
 * types the URL. Underneath both sits RLS, which is what actually protects the data.
 */
export function RequireRole({ allow }: { allow: readonly UserRole[] }) {
  const { data: profile, isPending } = useProfile();

  if (isPending) return <FullPageSpinner />;
  if (!profile || !allow.includes(profile.role)) {
    return <Navigate to="/forbidden" replace />;
  }

  return <Outlet />;
}
